import { useMemo } from 'react';
import {
  performComprehensiveBotAnalysis,
  type ComprehensiveBotDetectionResult,
} from '@/services/analytics/bot-detection';

/**
 * Bot-detection state for the Vercel Analytics integration.
 *
 * Advisory only: Vercel Analytics tracks pageviews from its own script, so this
 * cannot suppress a tracked event — it exists so bot traffic can be annotated
 * on the events this app sends itself.
 *
 * Detection is synchronous and runs once per mount, so the result never changes
 * for the lifetime of the component and never passes through a loading state.
 */
export function useVercelAnalytics(): {
  isBot: boolean;
  botInfo: ComprehensiveBotDetectionResult;
} {
  const detectionState = useMemo(() => {
    const detection = performComprehensiveBotAnalysis();
    return {
      isBot: detection.isBot,
      botInfo: detection,
    };
  }, []);

  return {
    isBot: detectionState.isBot,
    botInfo: detectionState.botInfo,
  };
}
